import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { END_POINT } from "constants/apiConstant";
import { ALL_MENU_ITEMS } from "constants/common";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  const HH = String(date.getHours()).padStart(2, "0");
  const MM = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return `${dd}-${mm}-${yyyy} ${HH}:${MM}:${ss}`;
};

export const getErrorMessage = (data) => {
  return (
    data?.ShippingMethod?.Error?.Errors?.[0]?.Message ||
    data?.PaymentMethod?.Error?.Errors?.[0]?.Message ||
    data?.Order?.Errors?.[0]?.Message
  );
};

export const capitalizeStr = (name) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const sortByDate = (array, key) => {
  if (key) {
    return array.sort((a, b) => new Date(b[key] || 0).getTime() - new Date(a[key] || 0).getTime());
  }
  return array;
};

export const getUrlByType = (type) => {
  console.log("type", type);
  switch (type.toLowerCase()) {
    case "mouser":
      return END_POINT.GET_TEST_MOUSER_API;
    case "digikey":
      return END_POINT.GET_TEST_DIGIKEY_API;
    case "element14":
      return END_POINT.GET_TEST_ELEMENT14_API;
    case "arrow":
      return END_POINT.GET_TEST_ARROW_API;
    case "tme":
      return END_POINT.GET_TEST_TME_API;
    case "tti":
      return END_POINT.GET_TEST_TTI_API;
    default:
      return END_POINT.GET_TEST_MOUSER_API;
  }
};

// Menu access keys for API: dashboard, uploaded_bom, search, orders, etc.
const HREF_TO_MENU_KEY = {
  "/dashboard": "dashboard",
  "/uploaded-bom": "uploaded_bom",
  "/search": "search",
  "/bom-analysis": "bom_analysis",
  "/my-orders": "orders",
  "/shipments": "shipments",
  "/history": "history",
  "/suppliers": "suppliers",
  "/analytics": "analytics",
  "/settings": "settings",
  "/bom-ai": "bom_ai",
};
export const getMenuAccessKey = (item) =>
  HREF_TO_MENU_KEY[item.href] || item.href.replace(/^\//, "").replace(/-/g, "_");

export const getDefaultMenuAccess = (view = false) =>
  ALL_MENU_ITEMS.reduce((acc, item) => {
    const key = getMenuAccessKey(item);
    acc[key] = { view };
    return acc;
  }, {});

// User account status → role. Backend createUser defaults new company users to
// status 4 ("user") and the company admin/owner is status 2 ("admin").
const STATUS_ROLE = { 2: "admin", 4: "user" };

// Resolve a user's role for display. Prefer an explicit company_role; fall back
// to the numeric account status when company_role is empty (it usually is).
export const getUserRole = (user) => {
  const explicit = (user?.company_role || user?.role || "")
    .toString()
    .toLowerCase()
    .trim();
  if (explicit) return explicit;
  return STATUS_ROLE[Number(user?.status)] || "user";
};
